var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useRef, useCallback, useMemo } from "react";
import "../styles/ArtGenerator.css";
import ChooseTheFormatStep from "../components/Steps/ChooseTheFormatStep";
import TitleStep from "../components/Steps/TitleStep";
import CustomizeYourCombosStep from "../components/Steps/CustomizeYourCombosStep";
import ColorAndLogoStep from "../components/Steps/ColorAndLogoStep";
import ChooseTheImageStep from "../components/Steps/ChooseTheImageStep";
import AdditionalInformationStep from "../components/Steps/AdditionalInformationStep";
import ArtGeneratorService from "../services/ArtGeneratorService";
import CreatedArts from "../components/CreatedArts";
import ModalSaveArtInformation from "../components/ModalSaveArtInformation";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import useContentSuppliers from "../../App/hooks/useContentSuppliers";
import ArtPreview from "../components/ArtPreview";
import ModalNameArt from "../components/ModalNameArt";
import Notification from "../../App/components/Notification";
import { handleServiceError } from "../../App/components/ErrorHandler";
import CloseIcon from '@mui/icons-material/Close';
var BLOCK_SELECTOR = "[data-id=art-generator]";
var EMPTY_FORM = {
    format: '',
    imagePosition: '',
    titleId: '',
    callToActionId: '',
    combos: [],
    colorCombinationId: '',
    logoFile: null,
    logoFilePath: null,
    imageId: '',
    additionalInfos: [],
    contactInfo: [],
};
function ArtGenerator() {
    var _this = this;
    var _a = useContentSuppliers(), contentSuppliersProducts = _a.contentSuppliersProducts, getAllContentSuppliersProducts = _a.getAllContentSuppliersProducts;
    var _b = useState([1]), openSteps = _b[0], setOpenSteps = _b[1];
    var _c = useState([]), images = _c[0], setImages = _c[1];
    var _d = useState([]), comboSvasOptions = _d[0], setComboSvasOptions = _d[1];
    var _e = useState([]), productGroups = _e[0], setProductGroups = _e[1];
    var _f = useState([]), colorCombinations = _f[0], setColorCombinations = _f[1];
    var _g = useState([]), layouts = _g[0], setLayouts = _g[1];
    var _h = useState(true), isCreatedArtsOpen = _h[0], setIsCreatedArtsOpen = _h[1];
    var _j = useState(true), isNewArtOpen = _j[0], setIsNewArtOpen = _j[1];
    var _k = useState([]), createdArts = _k[0], setCreatedArts = _k[1];
    var _l = useState(false), showSaveInfoModal = _l[0], setShowSaveInfoModal = _l[1];
    var _m = useState(false), showNameArtModal = _m[0], setShowNameArtModal = _m[1];
    var _o = useState(''), artName = _o[0], setArtName = _o[1];
    var artPreviewRef = useRef(null);
    var _p = useState(null), editingArtId = _p[0], setEditingArtId = _p[1];
    var _q = useState(0), formKey = _q[0], setFormKey = _q[1];
    var _r = useState(function () {
        var saved = localStorage.getItem('savedArtFormData');
        return saved ? JSON.parse(saved) : EMPTY_FORM;
    }), formData = _r[0], setFormData = _r[1];
    var fetchImages = useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var data, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    Notification().Block.circle(BLOCK_SELECTOR);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, ArtGeneratorService.getImages()];
                case 2:
                    data = _a.sent();
                    setImages(data);
                    return [3 /*break*/, 5];
                case 3:
                    err_1 = _a.sent();
                    handleServiceError(err_1);
                    return [3 /*break*/, 5];
                case 4:
                    Notification().Block.remove(BLOCK_SELECTOR);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, []);
    var fetchComboSvas = useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var data, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    Notification().Block.circle(BLOCK_SELECTOR);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, ArtGeneratorService.getComboSvas()];
                case 2:
                    data = _a.sent();
                    setComboSvasOptions(data);
                    return [3 /*break*/, 5];
                case 3:
                    err_2 = _a.sent();
                    handleServiceError(err_2);
                    return [3 /*break*/, 5];
                case 4:
                    Notification().Block.remove(BLOCK_SELECTOR);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, []);
    var fetchProductGroups = useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var data, err_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    Notification().Block.circle(BLOCK_SELECTOR);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, ArtGeneratorService.getProductGroups()];
                case 2:
                    data = _a.sent();
                    setProductGroups(data);
                    return [3 /*break*/, 5];
                case 3:
                    err_3 = _a.sent();
                    handleServiceError(err_3);
                    return [3 /*break*/, 5];
                case 4:
                    Notification().Block.remove(BLOCK_SELECTOR);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, []);
    var fetchLayouts = useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var data, err_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, ArtGeneratorService.getLayouts()];
                case 1:
                    data = _a.sent();
                    setLayouts(data);
                    return [3 /*break*/, 3];
                case 2:
                    err_4 = _a.sent();
                    handleServiceError(err_4);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); }, []);
    var fetchCreatedArts = useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var data, err_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    Notification().Block.circle(BLOCK_SELECTOR);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, ArtGeneratorService.getCreatedArts()];
                case 2:
                    data = _a.sent();
                    setCreatedArts(data);
                    return [3 /*break*/, 5];
                case 3:
                    err_5 = _a.sent();
                    handleServiceError(err_5);
                    setCreatedArts([]);
                    return [3 /*break*/, 5];
                case 4:
                    Notification().Block.remove(BLOCK_SELECTOR);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, []);
    var fetchColorCombinations = useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var data, err_6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    Notification().Block.circle(BLOCK_SELECTOR);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, ArtGeneratorService.getColorCombinations()];
                case 2:
                    data = _a.sent();
                    setColorCombinations(data);
                    return [3 /*break*/, 5];
                case 3:
                    err_6 = _a.sent();
                    handleServiceError(err_6);
                    return [3 /*break*/, 5];
                case 4:
                    Notification().Block.remove(BLOCK_SELECTOR);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, []);
    useEffect(function () { fetchImages(); }, [fetchImages]);
    useEffect(function () { fetchComboSvas(); }, [fetchComboSvas]);
    useEffect(function () { fetchProductGroups(); }, [fetchProductGroups]);
    useEffect(function () { fetchCreatedArts(); }, [fetchCreatedArts]);
    useEffect(function () { fetchLayouts(); }, [fetchLayouts]);
    useEffect(function () { fetchColorCombinations(); }, [fetchColorCombinations]);
    useEffect(function () { getAllContentSuppliersProducts(); }, []);
    useEffect(function () {
        if (createdArts.length > 0) {
            setIsCreatedArtsOpen(true);
            setIsNewArtOpen(false);
        }
        else {
            setIsCreatedArtsOpen(false);
            setIsNewArtOpen(true);
        }
    }, [createdArts]);
    var handleSaveArt = useCallback(function () {
        localStorage.setItem('savedArtFormData', JSON.stringify(formData));
        setShowSaveInfoModal(true);
    }, [formData]);
    var isStep1Valid = useCallback(function () {
        return formData.format === 'portrait' || formData.format === 'landscape';
    }, [formData.format]);
    var isStep2Valid = useCallback(function () {
        return formData.titleId !== '';
    }, [formData.titleId]);
    var isStep3Valid = useCallback(function () {
        return formData.combos.length > 0 && formData.combos.every(function (combo) {
            var _a, _b;
            return combo.selectedSvas.length > 0 &&
                ((_a = combo.monthlyValue) === null || _a === void 0 ? void 0 : _a.trim()) !== '' &&
                ((_b = combo.velocityValue) === null || _b === void 0 ? void 0 : _b.trim()) !== '';
        });
    }, [formData.combos]);
    var isStep4Valid = useCallback(function () {
        return !!formData.colorCombinationId && !!formData.logoFilePath && formData.logoFilePath.trim() !== '';
    }, [formData.colorCombinationId, formData.logoFilePath]);
    var isStep5Valid = useCallback(function () {
        return formData.imageId !== '';
    }, [formData.imageId]);
    var isStep6Valid = useCallback(function () {
        var _a, _b;
        var has_valid_info = ((_a = formData.additionalInfos) !== null && _a !== void 0 ? _a : []).some(function (info) { return info.id && info.value; });
        var has_valid_contact = ((_b = formData.contactInfo) !== null && _b !== void 0 ? _b : []).some(function (contact) { return contact.typeId && contact.value; });
        return has_valid_info || has_valid_contact;
    }, [formData.additionalInfos, formData.contactInfo]);
    var canOpenStep = useCallback(function (step) {
        if (step === 1)
            return true;
        var validators = {
            1: isStep1Valid, 2: isStep2Valid, 3: isStep3Valid,
            4: isStep4Valid, 5: isStep5Valid, 6: isStep6Valid,
        };
        return Array.from({ length: step - 1 }, function (_, index) { return index + 1; })
            .every(function (previousStep) { var _a, _b; return (_b = (_a = validators[previousStep]) === null || _a === void 0 ? void 0 : _a.call(validators)) !== null && _b !== void 0 ? _b : false; });
    }, [isStep1Valid, isStep2Valid, isStep3Valid, isStep4Valid, isStep5Valid, isStep6Valid]);
    var tryOpenNextStep = useCallback(function (currentStep) {
        var _a, _b;
        var validators = {
            1: isStep1Valid, 2: isStep2Valid, 3: isStep3Valid,
            4: isStep4Valid, 5: isStep5Valid, 6: isStep6Valid,
        };
        var is_valid = (_b = (_a = validators[currentStep]) === null || _a === void 0 ? void 0 : _a.call(validators)) !== null && _b !== void 0 ? _b : false;
        if (!is_valid)
            return;
        if (currentStep === 6) {
            setOpenSteps(function (prev) { return prev.filter(function (s) { return s !== 6; }); });
            handleSaveArt();
            return;
        }
        setOpenSteps(function (prev) { return __spreadArray(__spreadArray([], prev.filter(function (s) { return s !== currentStep; }), true), [currentStep + 1], false); });
    }, [isStep1Valid, isStep2Valid, isStep3Valid, isStep4Valid, isStep5Valid, isStep6Valid, handleSaveArt]);
    var handleToggleStep = useCallback(function (step) {
        setOpenSteps(function (prev) {
            if (prev.includes(step))
                return prev.filter(function (s) { return s !== step; });
            if (canOpenStep(step))
                return __spreadArray(__spreadArray([], prev, true), [step], false);
            return prev;
        });
    }, [canOpenStep]);
    var updateField = useCallback(function (field, value) {
        setFormData(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[field] = value, _a)));
        });
    }, []);
    var selectedProductIds = useMemo(function () {
        return Array.from(new Set(formData.combos.flatMap(function (combo) { return combo.selectedSvas.map(String); })));
    }, [formData.combos]);
    var selectedSupplierIds = useMemo(function () {
        var supplierIds = new Set();
        var allSvaIds = formData.combos.flatMap(function (combo) { return combo.selectedSvas; });
        var _loop_1 = function (svaId) {
            var product = contentSuppliersProducts.find(function (p) { return String(p.id) === String(svaId); });
            if (product === null || product === void 0 ? void 0 : product.content_supplier_id) {
                supplierIds.add(String(product.content_supplier_id));
            }
        };
        for (var _i = 0, allSvaIds_1 = allSvaIds; _i < allSvaIds_1.length; _i++) {
            var svaId = allSvaIds_1[_i];
            _loop_1(svaId);
        }
        return Array.from(supplierIds);
    }, [formData.combos, contentSuppliersProducts]);
    var orientationByFormat = {
        landscape: 'vertical',
        portrait: 'horizontal',
    };
    var filteredImages = useMemo(function () {
        var targetOrientation = orientationByFormat[formData.format];
        var filtered = images.filter(function (img) {
            var orientationMatch = !targetOrientation || String(img.orientation).toLowerCase() === targetOrientation;
            var productMatch = img.category === 'generic' ||
                (img.productId && selectedSupplierIds.includes(String(img.productId))) ||
                (img.productId && selectedProductIds.includes(String(img.productId)));
            return orientationMatch && productMatch;
        });
        return filtered;
    }, [images, selectedProductIds, selectedSupplierIds, formData.format]);
    var onConfirmSaveInfo = useCallback(function () {
        setShowSaveInfoModal(false);
        setShowNameArtModal(true);
    }, []);
    var handleDeleteArt = useCallback(function (id) { return __awaiter(_this, void 0, void 0, function () {
        var err_7;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, ArtGeneratorService.deleteGeneratedArt(id)];
                case 1:
                    _a.sent();
                    setCreatedArts(function (prev) { return prev.filter(function (art) { return art.id !== id; }); });
                    return [3 /*break*/, 3];
                case 2:
                    err_7 = _a.sent();
                    handleServiceError(err_7);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); }, []);
    var onConfirmNameArt = useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var layout, contactMap, phrase_ids, sva_ids, combos, payload, result, _a, previousArt, saved_art_1, err_8;
        var _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    if (!artName.trim())
                        return [2 /*return*/];
                    layout = layouts.find(function (l) { return l.slug === formData.imagePosition; });
                    if (!layout) {
                        return [2 /*return*/];
                    }
                    contactMap = {
                        contact_phone: null,
                        contact_email: null,
                        contact_suporte: null,
                        contact_instagram: null,
                    };
                    formData.contactInfo.forEach(function (c) {
                        if (!c.value)
                            return;
                        if (c.typeId === 'whatsapp')
                            contactMap.contact_suporte = c.value;
                        else if (c.typeId === 'telefone')
                            contactMap.contact_phone = c.value;
                        else if (c.typeId === 'email')
                            contactMap.contact_email = c.value;
                        else if (c.typeId === 'instagram')
                            contactMap.contact_instagram = c.value;
                    });
                    phrase_ids = Array.from(new Set(formData.additionalInfos
                        .filter(function (i) { return i.type === 'info'; })
                        .map(function (i) { return Number(i.id); })));
                    sva_ids = Array.from(new Set(formData.additionalInfos
                        .filter(function (i) { return i.type === 'sva'; })
                        .map(function (i) { return Number(i.id); })));
                    combos = formData.combos.map(function (c) { return ({
                        internet_speed: Number.parseInt(c.velocityValue, 10),
                        speed_unit: c.velocityUnit,
                        price: c.monthlyValue ? Number(c.monthlyValue) : null,
                        product_ids: c.selectedSvas.map(Number),
                    }); });
                    payload = __assign(__assign({ name: artName.trim(), art_layout_id: layout.id, art_title_id: Number(formData.titleId), art_background_id: formData.imageId ? Number(formData.imageId) : null, background_color_id: formData.colorCombinationId ? Number(formData.colorCombinationId) : null, logo_file_path: (_b = formData.logoFilePath) !== null && _b !== void 0 ? _b : null }, contactMap), { combos: combos, svas_logos_external_ids: sva_ids, additional_info_phrase_ids: phrase_ids });
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 6, , 7]);
                    if (!editingArtId) return [3 /*break*/, 3];
                    return [4 /*yield*/, ArtGeneratorService.updateGeneratedArt(editingArtId, payload)];
                case 2:
                    _a = _e.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, ArtGeneratorService.storeGeneratedArt(payload)];
                case 4:
                    _a = _e.sent();
                    _e.label = 5;
                case 5:
                    result = _a;
                    previousArt = editingArtId ? createdArts.find(function (art) { return art.id === editingArtId; }) : undefined;
                    saved_art_1 = {
                        id: String(result.data.id),
                        date: (_c = previousArt === null || previousArt === void 0 ? void 0 : previousArt.date) !== null && _c !== void 0 ? _c : new Date().toLocaleDateString('pt-BR', { day: '2-digit', month: 'short', year: 'numeric' }),
                        products: formData.combos.flatMap(function (c) { return c.selectedSvas; }),
                        imageId: formData.imageId,
                        format: formData.format === 'portrait' || formData.format === 'landscape'
                            ? formData.format
                            : undefined,
                        imagePosition: formData.imagePosition,
                        title: formData.titleId,
                        callToActionId: formData.callToActionId,
                        combos: formData.combos,
                        colorCombinationId: formData.colorCombinationId,
                        logoFilePath: formData.logoFilePath,
                        additionalInfos: formData.additionalInfos,
                        contactInfo: formData.contactInfo,
                        name: artName.trim(),
                    };
                    setCreatedArts(function (prev) {
                        return editingArtId
                            ? prev.map(function (art) { return art.id === editingArtId ? saved_art_1 : art; })
                            : __spreadArray(__spreadArray([], prev, true), [saved_art_1], false);
                    });
                    (_d = artPreviewRef.current) === null || _d === void 0 ? void 0 : _d.exportAsImage(artName.trim());
                    setEditingArtId(null);
                    setShowNameArtModal(false);
                    setArtName('');
                    setFormData(EMPTY_FORM);
                    setFormKey(function (k) { return k + 1; });
                    localStorage.removeItem('savedArtFormData');
                    return [3 /*break*/, 7];
                case 6:
                    err_8 = _e.sent();
                    handleServiceError(err_8);
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
            }
        });
    }); }, [artName, formData, layouts, editingArtId, createdArts]);
    var loadArtToEdit = useCallback(function (art) { return __awaiter(_this, void 0, void 0, function () {
        var fullArt, combos, contactInfo, additionalInfos, layout, err_9;
        var _a, _b, _c, _d, _e, _f, _g, _h;
        return __generator(this, function (_j) {
            switch (_j.label) {
                case 0:
                    _j.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, ArtGeneratorService.getGeneratedArtById(art.id)];
                case 1:
                    fullArt = _j.sent();
                    combos = ((_a = fullArt.combos) !== null && _a !== void 0 ? _a : []).map(function (c) {
                        var _a, _b, _c;
                        return ({
                            velocityValue: String((_a = c.internet_speed) !== null && _a !== void 0 ? _a : ''),
                            velocityUnit: (_b = c.speed_unit) !== null && _b !== void 0 ? _b : 'MEGA',
                            monthlyValue: c.price != null ? String(c.price) : '',
                            selectedSvas: ((_c = c.products) !== null && _c !== void 0 ? _c : []).map(function (p) { return String(p.id); }),
                        });
                    });
                    contactInfo = [];
                    if (fullArt.contact_suporte)
                        contactInfo.push({ typeId: 'whatsapp', value: fullArt.contact_suporte });
                    if (fullArt.contact_phone)
                        contactInfo.push({ typeId: 'telefone', value: fullArt.contact_phone });
                    if (fullArt.contact_email)
                        contactInfo.push({ typeId: 'email', value: fullArt.contact_email });
                    if (fullArt.contact_instagram)
                        contactInfo.push({ typeId: 'instagram', value: fullArt.contact_instagram });
                    additionalInfos = __spreadArray(__spreadArray([], ((_b = fullArt.additional_info_phrases) !== null && _b !== void 0 ? _b : []).map(function (p) { return ({
                        id: String(p.id),
                        value: p.text,
                        type: 'info',
                    }); }), true), ((_c = fullArt.svas_logos_external) !== null && _c !== void 0 ? _c : []).map(function (s) {
                        var _a, _b;
                        return ({
                            id: String(s.id),
                            value: (_b = (_a = s.name) !== null && _a !== void 0 ? _a : s.text) !== null && _b !== void 0 ? _b : '',
                            type: 'sva',
                        });
                    }), true);
                    layout = (_d = fullArt.layout) !== null && _d !== void 0 ? _d : {};
                    setFormData({
                        format: ((_e = layout.art_format) === null || _e === void 0 ? void 0 : _e.name) === 'retrato' ? 'portrait' : 'landscape',
                        imagePosition: (_f = layout.slug) !== null && _f !== void 0 ? _f : '',
                        titleId: fullArt.art_title_id ? String(fullArt.art_title_id) : '',
                        callToActionId: '',
                        combos: combos,
                        colorCombinationId: fullArt.background_color_id ? String(fullArt.background_color_id) : '',
                        logoFile: null,
                        logoFilePath: (_g = fullArt.logo_file_path) !== null && _g !== void 0 ? _g : null,
                        imageId: fullArt.art_background_id ? String(fullArt.art_background_id) : '',
                        additionalInfos: additionalInfos,
                        contactInfo: contactInfo,
                    });
                    setEditingArtId(art.id);
                    setIsNewArtOpen(true);
                    setIsCreatedArtsOpen(false);
                    setOpenSteps([1]);
                    setArtName((_h = fullArt.name) !== null && _h !== void 0 ? _h : '');
                    setFormKey(function (k) { return k + 1; });
                    return [3 /*break*/, 3];
                case 2:
                    err_9 = _j.sent();
                    handleServiceError(err_9);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); }, []);
    var resetToNewArt = useCallback(function () {
        setEditingArtId(null);
        setArtName('');
        setFormData(EMPTY_FORM);
        setOpenSteps([1]);
        setFormKey(function (k) { return k + 1; });
        localStorage.removeItem('savedArtFormData');
    }, []);
    return (_jsxs("div", __assign({ "data-id": "art-generator", className: "content-internal-padding", style: { backgroundColor: "rgb(248,248,248)" } }, { children: [createdArts.length > 0 && (_jsxs("div", __assign({ className: "accordion-section" }, { children: [_jsx("h2", __assign({ className: "accordion-title" }, { children: _jsxs("button", __assign({ type: "button", className: "accordion-title-btn", onClick: function () { return setIsCreatedArtsOpen(function (prev) { return !prev; }); } }, { children: [isCreatedArtsOpen ? _jsx(KeyboardArrowUpIcon, {}) : _jsx(KeyboardArrowDownIcon, {}), " Artes criadas"] })) })), isCreatedArtsOpen && (_jsx("div", __assign({ className: "accordion-content" }, { children: _jsx(CreatedArts, { arts: createdArts, onDelete: handleDeleteArt, products: contentSuppliersProducts, images: images, onSelect: loadArtToEdit }) })))] }))), _jsxs("div", __assign({ className: "accordion-section" }, { children: [_jsxs("h2", __assign({ className: "accordion-title" }, { children: [_jsxs("button", __assign({ type: "button", className: "accordion-title-btn", onClick: function () { return setIsNewArtOpen(function (prev) { return !prev; }); } }, { children: [isNewArtOpen ? _jsx(KeyboardArrowUpIcon, {}) : _jsx(KeyboardArrowDownIcon, {}), editingArtId ? " Editar: ".concat(artName) : ' Nova arte'] })), editingArtId && (_jsxs("button", __assign({ onClick: function (e) {
                                    e.stopPropagation();
                                    resetToNewArt();
                                }, className: "cancel-edit-button", type: "button", "aria-label": "Sair da edi\u00E7\u00E3o", style: { marginRight: '-48px' } }, { children: [_jsx(CloseIcon, { fontSize: "small" }), " Sair da edi\u00E7\u00E3o"] })))] })), isNewArtOpen && (_jsx("div", __assign({ className: "accordion-content" }, { children: _jsxs("div", __assign({ className: "two-column-layout" }, { children: [_jsxs("div", __assign({ className: "left-column" }, { children: [_jsx(ChooseTheFormatStep, { format: formData.format, onChange: function (value) {
                                                updateField('format', value);
                                                var position = '';
                                                if (value === 'portrait')
                                                    position = 'horizontal-retrato';
                                                else if (value === 'landscape')
                                                    position = 'horizontal';
                                                updateField('imagePosition', position);
                                                updateField('imageId', '');
                                            }, onNext: function () { return tryOpenNextStep(1); }, isOpen: openSteps.includes(1), onToggle: function () { return handleToggleStep(1); }, isValid: isStep1Valid() }), _jsx(TitleStep, { titleId: formData.titleId, onChange: function (value) { return updateField('titleId', value); }, onNext: function () { return tryOpenNextStep(2); }, isOpen: openSteps.includes(2), onToggle: function () { return handleToggleStep(2); }, isValid: isStep2Valid() }), _jsx(CustomizeYourCombosStep, { combos: formData.combos, onChange: function (value) { return updateField('combos', value); }, comboSvasOptions: comboSvasOptions, productGroups: productGroups, isOpen: openSteps.includes(3), onToggle: function () { return handleToggleStep(3); }, onNext: function () { return tryOpenNextStep(3); }, contentSuppliersProducts: contentSuppliersProducts, isValid: isStep3Valid() }), _jsx(ColorAndLogoStep, { colorCombinationId: formData.colorCombinationId, colorCombinations: colorCombinations, onChange: function (colorId) {
                                                updateField('colorCombinationId', colorId);
                                            }, onLogoPathChange: function (path) { return updateField('logoFilePath', path); }, isOpen: openSteps.includes(4), onToggle: function () { return handleToggleStep(4); }, onNext: function () { return tryOpenNextStep(4); }, isValid: isStep4Valid() }), _jsx(ChooseTheImageStep, { imageId: formData.imageId, onChange: function (val) { return updateField('imageId', val); }, images: filteredImages, isOpen: openSteps.includes(5), onToggle: function () { return handleToggleStep(5); }, onNext: function () { return tryOpenNextStep(5); }, products: contentSuppliersProducts, isValid: isStep5Valid() }), _jsx(AdditionalInformationStep, { additionalInfos: formData.additionalInfos, contactInfo: formData.contactInfo, onChange: function (_a) {
                                                var infos = _a.infos, svas = _a.svas, contacts = _a.contacts;
                                                updateField('additionalInfos', __spreadArray(__spreadArray([], infos, true), svas, true));
                                                updateField('contactInfo', contacts);
                                            }, isOpen: openSteps.includes(6), onToggle: function () { return handleToggleStep(6); }, onNext: handleSaveArt, onExport: function () { var _a; return (_a = artPreviewRef.current) === null || _a === void 0 ? void 0 : _a.exportAsImage((artName === null || artName === void 0 ? void 0 : artName.trim()) || 'arte'); }, isValid: isStep6Valid() })] })), _jsx("div", __assign({ className: "right-column" }, { children: _jsx(ArtPreview, { formData: formData, images: images, comboSvasOptions: comboSvasOptions, ref: artPreviewRef, contentSuppliersProducts: contentSuppliersProducts }) }))] }), formKey) })))] })), _jsx(ModalSaveArtInformation, { show: showSaveInfoModal, closeModal: function () { return setShowSaveInfoModal(false); }, onConfirm: onConfirmSaveInfo }), _jsx(ModalNameArt, { show: showNameArtModal, closeModal: function () { return setShowNameArtModal(false); }, artName: artName, setArtName: setArtName, onConfirm: onConfirmNameArt })] })));
}
export default ArtGenerator;
